<template>
  <!-- <Tabs v-model="saleType"
            :animated="false"
            :capture-focus="true"> 
            <TabPane label="定金单列表"
                name="preSale">
                <PreSaleOrderList v-model="saleType"
                    ref="preSaleOrderList" />
            </TabPane>
        </Tabs> -->
			<Row :gutter="16">
				  <Col span="24" label="定金单列表" name="depositType">
			<div class="global-tool-bar">
			<DepositOrderList  v-model="depositType"
						ref="depositOrderList" />
			</div>
		    </Col>
		</Row>
</template>

<script>
import DepositOrderList from '../../preSale-management/preSale-order/deposit-order-list';

export default {
    name: 'deposit-list',
    components: {
        DepositOrderList
    },
    data() {
        return {
            depositType: 'depositType'
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
